<template>
  <button type="button" class="mall-disc-button" :class="{ active, needle, lace, 'theme-1': theme === '1', 'theme-2': theme === '2' }" @click="handleClick">
    <div class="disc" :class="{ gold }">
      <template v-if="img">
        <img :data-src="img | replaceUrlProtocol" class="lazyload" v-if="lazy">
        <img :src="img | replaceUrlProtocol" v-else>
      </template>
    </div>
  </button>
</template>

<script>
export default {
  name: 'MallDiscButton',

  props: {
    active: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: '1'
    },

    lace: {
      type: Boolean,
      default: true
    },

    gold: {
      type: Boolean,
      default: false
    },

    needle: {
      type: Boolean,
      default: false
    },

    img: {
      type: String,
      default: ''
    },

    lazy: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@cdn_css/helper.scss";

.mall-disc-button {
  position: relative;
  display: block;
  background-color: transparent;
  border: 0;

  .disc {
    width: 100%;
    height: 100%;
  }

  &.theme-1 {
    &:before {
      position: absolute;
      z-index: 2;
      width: 28px;
      height: 28px;
      content: "";
      @extend %center-xy;
      @include bg-img("~@cdn_img/play-blur.svg", 100%);
    }

    &.active {
      &:before {
        width: 28px;
        height: 28px;
        @extend %center-xy;
        @include bg-img("~@cdn_img/stop-blur.svg", 100%);
      }

      .disc {
        animation: rotate 10s linear 0s infinite;
      }
    }

    &.needle {
      &:after {
        position: absolute;
        top: 3px;
        right: -19px;
        z-index: 2;
        width: 36px;
        height: 58px;
        transform: rotate(0deg);
        transform-origin: 14px 5px;
        transition: transform 0.5s;
        content: "";
        @include bg-img("~@cdn_img/icon-44.svg", 100%);
      }

      &.active {
        &:after {
          transform: rotate(25deg);
        }

        .disc {
          animation-delay: 0.5s;
        }
      }
    }

    .disc {
      transform: rotate(0deg);

      &:before {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        content: "";
        @include bg-img("~@cdn_img/disc.svg", 100%);
      }

      img {
        position: absolute;
        z-index: 1;
        display: block;
        width: 90%;
        height: 90%;
        object-fit: cover;
        border-radius: 50%;
        @extend %center-xy;
      }

      // &.gold {
      //   &:before {
      //     @include bg-img("~@cdn_img/disc-lace-gold.svg", 100%);
      //   }
      // }
    }

    &.lace {
      .disc {
        &:before {
          background-image: url("~@cdn_img/disc-lace.svg");
        }

        &.gold {
          &:before {
            @include bg-img("~@cdn_img/disc-lace-gold.svg", 100%);
          }
        }
      }
    }
  }

  &.theme-2 {
    img {
      position: relative;
      z-index: 1;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }

    &:before {
      position: absolute;
      z-index: 2;
      width: 28px;
      height: 28px;
      content: "";
      @extend %center-xy;
      @include bg-img("~@cdn_img/play-blur.svg", contain);
    }

    &:after {
      position: absolute;
      top: 1px;
      right: -11px;
      z-index: 0;
      width: 80px;
      height: 80px;
      transition: right 0.2s ease-out;
      content: "";
      @include bg-img("~@cdn_img/disc-solid.svg", contain);
    }

    &.active {
      &:before {
        width: 28px;
        height: 28px;
        @extend %center-xy;
        @include bg-img("~@cdn_img/stop-blur.svg", contain);
      }

      &:after {
        right: -15px;
        animation: rotate 6s linear infinite;
      }
    }
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}
</style>
